import type { SubmittedToFunderFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { TRAINING_ITEM_TYPE } from "@academy-context/shared/domain/types/training-items";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveSubmittedToFunderFundingRequests = createApiThunk<
  SubmittedToFunderFundingRequestVM[],
  { funders: string[]; trainingItemTypes?: TRAINING_ITEM_TYPE[] } | undefined
>(
  "fundingRequests/retrieveSubmittedToFunderFundingRequests",
  async (filters: { funders: string[]; trainingItemTypes?: TRAINING_ITEM_TYPE[] } | undefined, { extra: { adminRepository } }) => {
    const requests = await adminRepository!.getAll({
      status: ["submitted_to_funder"],
      funders: filters?.funders,
      trainingItemTypes: filters?.trainingItemTypes,
    });
    const response: SubmittedToFunderFundingRequestVM[] = [];
    for (const r of requests) {
      if (r.status === "submitted_to_funder") {
        response.push(r);
      }
    }
    return response;
  },
);
